import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export const initialize = createAction(`${actionTypePrefix}/INITIALIZE`, (username)=>({
        username
    }));
export const requestSuccess = createAction(`${actionTypePrefix}/REQUEST_SUCCESS`, (username, data)=>({
        username,
        data
    }));
export const requestFailure = createAction(`${actionTypePrefix}/REQUEST_FAILURE`, (username)=>({
        username
    }));
